import countriesJSON from './countries.json'
import usStatesJSON from '../statesOrProvinces/US.json'
import caProvincesJSON from '../statesOrProvinces/CA.json'

/**
 * These types live here due to a circular dependency between the utils and order-schemas libs, we
 * might want to refactor this some time.
 */
export type Country = { label: string; value: string; labelEs: string }
export type Countries = Country[]

export type StateOrProvince = { label: string; value: string }
export type StatesOrProvinces = StateOrProvince[]
export type StateOrProvinceMap = Record<Country['value'], StatesOrProvinces>

export const countries: Countries = countriesJSON.map((country) => ({
  value: country.alpha2Value,
  label: country.label,
  labelEs: country.labelEs,
}))
export const countryFromAlpha3: (alpha3?: string) => Country | undefined = (alpha3) => {
  if (!alpha3) {
    return undefined
  }
  const result = countriesJSON.find(({ alpha3Value }) => alpha3Value === alpha3)
  if (result) {
    return { value: result.alpha2Value, label: result.label, labelEs: result.labelEs }
  }
  return undefined
}

export const resolveCountryCodeToAlpha2 = (input?: string | number) => {
  if (!input) {
    return undefined
  }
  if (typeof input === 'number') {
    return countriesJSON.find(({ internationalCode }) => internationalCode === input)?.alpha2Value
  }
  if (typeof input === 'string' && input.length === 2) {
    return countriesJSON.find(({ alpha2Value }) => alpha2Value === input)?.alpha2Value
  }
  if (typeof input === 'string' && input.length === 3) {
    return countriesJSON.find(({ alpha3Value }) => alpha3Value === input)?.alpha2Value
  }
  return undefined
}

export const resolveCountryCodeToDiallingCode = (input?: string | number) => {
  if (!input) {
    return undefined
  }
  if (typeof input === 'number') {
    return (
      countriesJSON.find(({ internationalCode }) => internationalCode === input)
        ?.internationalCode || undefined
    )
  }
  if (typeof input === 'string' && input.length === 2) {
    return (
      countriesJSON.find(({ alpha2Value }) => alpha2Value === input)?.internationalCode || undefined
    )
  }
  if (typeof input === 'string' && input.length === 3) {
    return (
      countriesJSON.find(({ alpha3Value }) => alpha3Value === input)?.internationalCode || undefined
    )
  }
  return undefined
}

export const getCountryNameFromCountryCode = (input?: string, language: 'en' | 'es' = 'en') => {
  const alpha2 = resolveCountryCodeToAlpha2(input)
  const country = countriesJSON.find(({ alpha2Value }) => alpha2Value === alpha2)
  if (language === 'en') {
    return country?.label
  }
  return country?.labelEs
}

export const stateOrProvinceMap: StateOrProvinceMap = {
  US: usStatesJSON,
  CA: caProvincesJSON,
}
